module.exports = __webpack_public_path__ + "img/Group6.a3bff73d.svg";